// extracted by mini-css-extract-plugin
export default {"themeSpacing":"8px","sidebarWidth":"360px","controlsSpacing":"10px","popup":"OnboardingPopup_popup__srv7"};